import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from '@/components/Shop/ShopAds/ShopAdsSection.styles';
import { SORT_OPTIONS } from '@/components/Shop/Shop.constants';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';
import { SortBottomSheetProps } from '@/api/types/shop.types';

export const SortBottomSheet: React.FC<SortBottomSheetProps> = ({
  isOpen,
  close,
  selectedSort,
  onSelect,
  text,
}) => {
  const { t } = useTranslation();

  return (
    <BottomSheet
      dataTestId="sort-bottom-sheet"
      isOpen={isOpen}
      close={close}
      title={text}
      isInPortal
    >
      {SORT_OPTIONS.map(option => (
        <S.SortOptionButton
          key={option.value}
          onClick={() => {
            onSelect(option.value);
            close();
          }}
        >
          {t(option.tKey)}
          <S.SortOptionRadio $active={selectedSort === option.value} />
        </S.SortOptionButton>
      ))}
    </BottomSheet>
  );
};
